export async function post<TYPE>({
  url,
  signal,
  body,
}: {
  url: string;
  signal: AbortSignal;
  body?: any;
}) {
  try {
    const response = await fetch(`${url}`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body),
      signal,
    });

    const json: TYPE = await response.json();

    return [json, response] as const;
  } catch (e) {
    return [undefined];
  }
}
